"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./UserNav.css");

var _UserNavItem = _interopRequireDefault(require("./UserNavItem"));

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _Typography = _interopRequireDefault(require("../../Typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
Sub-component to display avatar and user info in the dropdown
*/
function UserNavUser(_ref) {
  var avatar = _ref.avatar,
      name = _ref.name,
      email = _ref.email,
      loginSource = _ref.loginSource;
  if (!name) return null;
  return /*#__PURE__*/_react["default"].createElement(_UserNavItem["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_usernav__userbox"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    className: "st_usernav__avatar",
    size: "xl",
    avatar: avatar,
    initials: name.charAt(0)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_usernav__usertext"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    weight: "bold",
    size: "md",
    truncate: true
  }, name), email && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    size: "sm",
    color: "asphalt",
    truncate: true
  }, email))), loginSource && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    size: "sm",
    color: "asphalt",
    margin: {
      vertical: 'smd'
    }
  }, "You are logged in via ", typeof loginSource === 'string' ? loginSource : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "link",
    inline: true,
    componentEl: "a",
    href: loginSource.url,
    rel: "noopener noreferrer",
    target: "_blank"
  }, loginSource.text)), loginSource.settingUrl && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    secondary: true,
    componentEl: "a",
    href: loginSource.settingUrl,
    rel: "noopener noreferrer",
    target: "_blank",
    fullWidth: true
  }, "Manage your ", loginSource.text, " Account")));
}

UserNavUser.propTypes = {
  /** url to avatar */
  avatar: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].string]),

  /** name to display */
  name: _propTypes["default"].string,

  /** email address, if any */
  email: _propTypes["default"].string,

  /**
   * login source, if any, This can be a string with the source name or an
   * object with `text` of the login source name, `url` to link to the login
   * source and a `settingUrl` to link to the users settings/account page
   * */
  loginSource: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    settingUrl: _propTypes["default"].string
  }), _propTypes["default"].string])
};
UserNavUser.defaultProps = {
  avatar: null,
  name: null,
  email: null,
  loginSource: null
};
UserNavUser.displayName = 'HeaderBar.User.User';
var _default = UserNavUser;
exports["default"] = _default;